export enum ContentType {
  InOffice = "InOffice",
  Exclude = "Exclude",
  Holiday = "Holiday",
}
